import React, {Component} from 'react';
// import avatar from '../../../views/pages/images/user.jpeg';
import { Link } from 'react-router-dom';


// style
import './style.css'

import logo from '../../../assets/logo/avitech_logo_white.png'
const styles = {position:'fixed',width:'100%',zIndex:'2', background: 'rgba(0,0,0,0.8)',filter:'saturate(180%)',boxShadow:'0 2px 6px rgba(0,0,0,.4)',flexDirection:'row'}
class HeaderComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
          selected : 0
        }
    }

    handleClick = (index, e) => {
        let c = e.currentTarget.class;
        this.setState({
            selected: (c.indexOf('selected') >= 0) ? '' : index
        })
    };
    componentDidMount(){
        const href = window.location.href.split('/');
        const page_url = href.pop();
        let selected = 0;
        if(page_url === 'about'){
            selected = 1;
        }else if(page_url === 'products'){
            selected = 2;
        }else if(page_url === 'contact-us'){
            selected = 3
        }else if(page_url === 'ebips'){
            selected = 4
        }
        this.setState({selected: selected});
    }

    render() {
        return (
            <div>
                <nav className="navbar navbar-expand-lg navbar-light" style={styles}>
                    <a className="navbar-brand"  style={{width:'55%'}}><img src={logo} alt="Avitech" className="img-logo" style={{width:'13vh',heigth:'auto', marginLeft:'15px'}} /></a>

                    <button className="navbar-toggler" style={{background:'white'}} type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">

                        <div className="form-inline my-2 my-lg-0">
                            <ul className="navbar-nav mr-auto navbar-right">
                                <li className="nav-item active">
                                    <Link to='/'  onClick={this.handleClick.bind(this, 0)} className={(this.state.selected === 0) ? ' active': ''}>  <span className="nav-link">HOME <span className="sr-only">(current)</span></span></Link>
                                </li>
                                <li className="nav-item">
                                    <Link to='/about'  onClick={this.handleClick.bind(this, 1)} className={(this.state.selected === 1) ? ' active': ''}>   <span className="nav-link">ABOUT</span></Link>
                                </li>
                                <li className="nav-item">
                                    <Link to='/products'  onClick={this.handleClick.bind(this, 2)} className={(this.state.selected === 2) ? ' active': ''}>   <span className="nav-link">PRODUCTS</span></Link>
                                </li>
                                <li className="nav-item">
                                    <Link to='/contact-us'  onClick={this.handleClick.bind(this, 3)} className={(this.state.selected === 3) ? ' active': ''}>   <span className="nav-link">CONTACT US</span></Link>
                                </li>
                                <li className="nav-item">
                                    <Link to='/ebips'  onClick={this.handleClick.bind(this, 4)} className={(this.state.selected === 4) ? ' active': ''}>   <span className="nav-link">EBIPS</span></Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>

            </div>
        );
    }

}

export default HeaderComponent;



// WEBPACK FOOTER //
// ./src/shared/components/header/index.js